export default "__VITE_ASSET__D2hnULxO__"